import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

function BalingWire() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/service-department">Service Department</Link>
          <Link to="/baler-refurbishing-services">Baler Refurbishing Services</Link>
          <Link to="/baler-replacement-parts">Baler Replacement Parts</Link>
          <Link className="active" to="/baling-wire">Baling Wire</Link>
          <Link to="/contact/baling-wire">Baling Wire Quotation</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Parts &amp; Service</span>
          <h2>Baling Wire</h2>
          <div className="gold-note">Note: Replacement or spare wear parts, quick-lock and single loop baling wire, and factory or field repair services are available as needed. Expedited and special order parts can be shipped by contacting our parts department at (336) 723-4869 or (800) 225-3796 or by email at <a href="mailto:parts@baling.com">parts@baling.com</a>. C+M Technical Services can be contacted via our general number (336) 723-1838.</div>
          <div className="content-stack">
            <section className="content-block">
              <div className="selection-media-row">
                <div className="selection-media-copy">
                  <div className="body-copy">Baling wire can be shipped from C+M inventory or from our distributors located across the USA and shipped by <strong>sea container</strong> to most anywhere in the world.</div>
                  <div className="body-copy">Commonly used <strong>single loop wire</strong> in numerous lengths and gauges is priced to retain your business. Quick-Lock wire of standard lengths can be shipped from multiple locations, and <strong>custom wire lengths</strong> can be ordered, manufactured, and shipped within a few days.</div>
                </div>
                <img className="service-side-image" src="/img/thumbnails/BalingWirePic1.jpg" alt="Quick-lock baling wire" />
              </div>
            </section>
            <section className="content-block">
              <div className="selection-media-row reverse">
                <div className="selection-media-copy">
                  <div className="body-copy">Auto-tie wire is sold in pallet lots of 36 each 100 pound or 50 pound boxes, or at a slightly higher cost, as single boxes.</div>
                  <div className="body-copy">Request a <strong>baling wire</strong> quotation or call or email our parts department for help selecting the right baling wire for your equipment and tying system.</div>
                </div>
                <img className="service-side-image" src="/img/equipment/accessories-parts/accessories-parts-1.jpg" alt="Coiled baling wire and boxed auto-tie wire" />
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/baling-wire">Request Wire Pricing <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default BalingWire;
